// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

// Vuetify
import { createVuetify } from "vuetify";
import { VTreeview } from "vuetify/lib/labs/components.mjs";
const myCustomTheme = {
  dark: false,
  colors: {
    primary: "#5d87ff",
    background: "#FFFFFF",
    secondary: "#F57425FF",
    tertiary: "#808080",
  },
};

export default createVuetify({
  theme: {
    defaultTheme: "myCustomTheme",
    themes: {
      myCustomTheme,
    },
  },
  components:{
    VTreeview
  }
});